function getCookie(name) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  let value = v ? v[2] : null;
  try {
    value = JSON.parse(value);
  } catch (error) { }
  return value;
}
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  value = typeof value === 'object' ? JSON.stringify(value) : value;
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
}
function deleteCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export default {
  getCookie: getCookie,
  setCookie: setCookie,
  deleteCookie: deleteCookie
};
